import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import { AddProjectButton } from './add-project-button';
import { ExtraOptionsMenu } from './extra-options-menu';
import * as Styled from './page-top-bar.style';
import { ProjectsOverviewFilterButton } from './projects-overview-filter-button';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TopBarBase hideBorder>
      <Styled.Container>
        <Styled.Title>
          <Typography variant="h5" component="h1">
            {t('projects.title')}
          </Typography>
        </Styled.Title>

        <Styled.Interactions>
          <ProjectsOverviewFilterButton />
          <ExtraOptionsMenu />
          <AddProjectButton />
        </Styled.Interactions>
      </Styled.Container>
    </TopBarBase>
  );
};
